import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, InputGroup, Modal, Pagination,Image } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { BsPencilSquare, BsTrash, BsSearch, BsSortDown, BsSortUp,BsPlus } from 'react-icons/bs';
import { API_ENDPOINTS } from '../config'; // Import API endpoints

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [editingVideo, setEditingVideo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [videosPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('title');
  const [sortDirection, setSortDirection] = useState('asc');
  const [videoModalShow, setVideoModalShow] = useState(false);
  const [categoryModalShow, setCategoryModalShow] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
   const [thumbnailFile, setThumbnailFile] = useState(null); // New state for thumbnail file
  const [newVideo, setNewVideo] = useState({
    title: '',
    description: '',
    category: '',
    subCategory: '',
    videoLink: '',
    thumbnail: null,
  });
  const [newSubCategory, setNewSubCategory] = useState({
    name: '',
    subCategoryImage: null,
    categoryId: '',
  });

  useEffect(() => {
    fetchVideos();
    fetchCategories();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.getAllVideos, {
        headers: {
          'token': localStorage.getItem('token'),
        }
      });
      setVideos(response.data);
    } catch (error) {
      console.error('Error fetching videos:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.listAllCategories, {
        headers: {
          'token': localStorage.getItem('token'),
        }
      });
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchSubCategories = async (categoryId) => {
    try {
      console.log("--",categoryId)
      const response = await axios.get(API_ENDPOINTS.listAllSubCategoriesAdmin, {
        headers: {
          'cId': categoryId,
          'token': localStorage.getItem('token'),
        }
      });
      //console.log('Fetched subcategories:', response.data.subCategories);
      setSubCategories(response.data.subCategories);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
    }
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
   /* let categoryId = '';
    if (value === 'Exercise') {
      categoryId = 'CG8461060066';
    } else if (value === 'Yoga') {
      categoryId = 'CG1550821660';
    }
    */
   if (videoModalShow) {
      setNewVideo({ ...newVideo, category: value });
    } 
    
    setNewSubCategory({ ...newSubCategory, value });
    fetchSubCategories(value);
    
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setNewVideo({
      ...newVideo,
      [name]: files ? files[0] : value,
    });
  };

  const handleChangeSubCategory = (e) => {
    const { name, value, files } = e.target;
    setNewSubCategory({
      ...newSubCategory,
      [name]: files ? files[0] : value,
    });
  };

  const handleFileChange = (e) => {
  
    setThumbnailFile(e.target.files[0]); 
   
 };

 //------------------ Add
 const handleSubmitVideo = async () => {
  try {
    const formData = new FormData();
    //console.log("--",newVideo);
    formData.append('title', newVideo.title);
    formData.append('description', newVideo.description);
    formData.append('categoryId', newVideo.category);
    formData.append('subCategoryId', newVideo.subCategory);
    formData.append('videoLink', newVideo.videoLink);
   
    if (thumbnailFile) {
      formData.append('thumbnail', thumbnailFile);
    } else {
      formData.append('thumbnail', newVideo.thumbnail); // Fallback if no file is selected
    }
    const response = await axios.post(API_ENDPOINTS.addVideo, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'token': localStorage.getItem('token'), // Apply token here
      },
    });
    setVideoModalShow(false);
    fetchVideos(); 
  } catch (error) {
    console.error('Error adding video:', error.response ? error.response.data : error.message);
    // Handle error (e.g., show error message)
  }
};


  const handleSubmitSubCategory = async () => {
    const formData = new FormData();
    formData.append('name', newSubCategory.name);
    formData.append('categoryId', newSubCategory.categoryId);
    //console.log("---",newSubCategory.subCategoryImage)
    if (newSubCategory.subCategoryImage) {
      formData.append('subCategoryImage', newSubCategory.subCategoryImage);
    }

    try {
      const response = await axios.post(API_ENDPOINTS.addSubCategory, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': localStorage.getItem('token'),
        },
      });
      console.log('Subcategory added successfully:', response.data);
      setCategoryModalShow(false);
      fetchCategories();
      fetchSubCategories(newSubCategory.category);
    } catch (error) {
      console.error('Error adding subcategory:', error.message);
      if (error.response) {
        console.error('Error response data:', error.response.data);
      } else {
        console.error('Error without response:', error.message);
      }
    }
  };

  const handleDeleteVideo = async (videoId) => {
    if (window.confirm('Are you sure you want to delete this video?')) {
      try {
        await axios.delete(API_ENDPOINTS.deleteVideo, {
          headers: {
            'token': localStorage.getItem('token'),
            'videoId': videoId
          }
        });
        fetchVideos();
      } catch (error) {
        console.error('Error deleting video:', error);
      }
    }
  };

  const handleEditVideo = (video) => {
   setNewVideo(video);
    setEditingVideo({ ...video });
    setVideoModalShow(true);
  };
 
  const handleChangeEdit = (e) => {
    const { name, value, files } = e.target;
    setEditingVideo({
      ...editingVideo,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmitEdit = async () => {
   /*  const formData = new FormData();
    for (const key in editingVideo) {
      formData.append(key, editingVideo[key]);
    } */
   const formData = new FormData();
    formData.append('title', newVideo.title);
    formData.append('description', newVideo.description);
    formData.append('categoryId', newVideo.category);
    formData.append('subCategoryId', newVideo.subCategory);
    formData.append('videoLink', newVideo.videoLink);
    if (thumbnailFile) {
      formData.append('thumbnail', thumbnailFile);
    } else {
      formData.append('thumbnail', newVideo.thumbnail); // Fallback if no file is selected
    }

    try {
      const response = await axios.patch(API_ENDPOINTS.editVideo, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': localStorage.getItem('token'),
          'videoId': editingVideo._id
        }
      });
      console.log('Video updated successfully:', response.data);
      setEditingVideo(null);
      setVideoModalShow(false);
      fetchVideos();
    } catch (error) {
      console.error('Error updating video:', error);
    }
  };

  const sortVideos = (field) => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedAndFilteredVideos = videos
    .filter(video =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      video.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

//console.log("---",newVideo);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="w-100">
        <Header />
        <Container fluid>
          <Row>
            <Col>
              <div className="d-flex  align-items-center mb-3">
                    <h2>Fitness Videos </h2>&nbsp;&nbsp;&nbsp;
                    
                    <Button variant="primary" onClick={() => setVideoModalShow(true)}>
                      <BsPlus /> Add Video
                    </Button>&nbsp;&nbsp;&nbsp;
                    <Button variant="primary" onClick={() => setCategoryModalShow(true)}>
                      <BsPlus /> Add Subcategory
                    </Button>
                    <span></span>
                </div>
                
              <InputGroup className="mb-3">
                <Form.Control
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button variant="outline-secondary" onClick={() => sortVideos('title')}>
                  Sort By Title {sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />}
                </Button>
                <Button variant="outline-secondary" onClick={() => sortVideos('description')}>
                  Sort By Description {sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />}
                </Button>
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Image</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedAndFilteredVideos.slice((currentPage - 1) * videosPerPage, currentPage * videosPerPage)
                    .map((video, index) => (
                      <tr key={video.videoId}>
                        <td>{index + 1}</td>
                        <td>{video.title.length  > 50 ?`${video.title.substring(0, 50)}...` : video.title } </td>
                        <td>{video.description.length  > 50 ?`${video.description.substring(0, 150)}...` : video.description } </td>
                        <td><Image src={video.thumbnail}  fluid style={{ width: '80px', height: 'auto' }} /></td>
                        <td>
                          <Button variant="warning" onClick={() => handleEditVideo(video)}>
                            <BsPencilSquare />
                          </Button>
                          <Button variant="danger" onClick={() => handleDeleteVideo(video.videoId)}>
                            <BsTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({ length: Math.ceil(videos.length / videosPerPage) }, (_, i) => (
                  <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => paginate(i + 1)}>
                    {i + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>

        {/* Video Modal */}
        <Modal show={videoModalShow} onHide={() => setVideoModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{editingVideo ? 'Edit Video' : 'Add Video'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formVideoTitle">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={newVideo.title} 
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group controlId="formVideoDescription">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={newVideo.description}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group controlId="formVideoCategory">
                <Form.Label>Category</Form.Label>
                <Form.Control
                  as="select"
                  name="category"
                  value={newVideo?.categoryId} 
                  onChange={handleCategoryChange}
                >
                  <option value="">Select Category</option>
                  {categories.map(cat => (
                    <option key={cat._id} value={cat.categoryId}>{cat.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formVideoSubCategory">
                <Form.Label>Subcategory</Form.Label>
                <Form.Control
                  as="select"
                  name="subCategory"
                  value={newVideo?.subCategoryId}
                  onChange={handleChange}
                >
                  <option value="">Select Subcategory</option>
                  {subCategories.map(sub => (
                    <option key={sub._id} value={sub.subCategoryId}>{sub.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formVideoLink">
                <Form.Label>Video Link</Form.Label>
                <Form.Control
                  type="text"
                  name="videoLink"
                  value={newVideo.videoLink}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group controlId="formVideoThumbnail">
                <Form.Label>Thumbnail</Form.Label>
                <Form.Control
                  type="file"
                  name="thumbnail"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setVideoModalShow(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={editingVideo ? handleSubmitEdit : handleSubmitVideo}>
              {editingVideo ? 'Save Changes' : 'Add Video'}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Subcategory Modal */}
        <Modal show={categoryModalShow} onHide={() => setCategoryModalShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Subcategory</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formSubCategoryName">
                <Form.Label>Subcategory Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={newSubCategory.name}
                  onChange={handleChangeSubCategory}
                />
              </Form.Group>
              <Form.Group controlId="formSubCategoryCategory">
                <Form.Label>Category</Form.Label>
                <Form.Control
                  as="select"
                  name="category"
                  value={newVideo.category}
                  onChange={handleCategoryChange}
                >
                  <option value="">Select Category</option>
                  {categories.map(cat => (
                    <option key={cat._id} value={cat.name}>{cat.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formSubCategoryImage">
                <Form.Label>Subcategory Image</Form.Label>
                <Form.Control
                  type="file"
                  name="subCategoryImage"
                  onChange={handleChangeSubCategory}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setCategoryModalShow(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmitSubCategory}>
              Add Subcategory
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Videos;
